"use strict";
import * as React from "react";
import { useParams } from "react-router-dom";
import QuickSight from "../common/QuickSight";
import { mainPageInfoList } from "../../_constants/PageInfoList";
import { viewId } from "../../_constants/Code";

const KPI = (props) => {
  const page = mainPageInfoList.find(page => { return page.key === "S2"; });
  return (
    <main className="page-container">
      <section className="page-content">
        <div className="centered-container">
          <QuickSight
            pageId={viewId.kpi}
            pageInfo={page}
            dashboardList={page.dashboardList}
            listNum={props.params.listNum}
            listNumSub={props.params.listNumSub}
            isKpi={true}
            isBenchmark={true}
          />
        </div>
      </section>
    </main>
  );
};

export default (props) => <KPI {...props} params={useParams()} />;
